import React, { FunctionComponent, useState } from "react";
import {
  Fab,
  Button,
  Grid,
  Table,
  Dialog,  
} from "@material-ui/core";
import { api } from "../../../api";
import Switch from "@material-ui/core/Switch";
import DescriptionIcon from "@material-ui/icons/Description";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Tooltip from "@material-ui/core/Tooltip";
import MUIDataTable from "mui-datatables";
import { useStore } from "../../../store";
import { SnackBar } from "../../SnackBar";
import { useTableStyles } from "../../useTableStyle";
import { useVoucherStyles } from "../useVoucherStyles";
//import { VoucherManagement } from "../VoucherManagement";
import { VoucherDetailsList } from "./VoucherDetailsList";
import { ThemeProvider } from "@mui/material/styles";
const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const columns = ["Name", "Active", "", ""];

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

type VoucherProps = {
  editVoucherPermission: boolean;
};

export const VoucherTable: FunctionComponent<VoucherProps> = ({
  editVoucherPermission,
}) => {
  const classes = useVoucherStyles();
  const getMuiTheme = useTableStyles();
  const [voucher, { getVouchers, updateVoucher }] = useStore("vouchers");
  const [vouId, setVouId] = useState<number>();
  const [vouName, setVouName] = useState<string>("");
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [voucherStatus, setVoucherStatus] = useState<string>("");
  const [status, setStatus] = useState(voucher?.is_active || false);
  const [showVoucherDetails, setShowVoucherDetails] = useState<Boolean>(false);
  const [voucherDetails, setVoucherDetails] = useState<Array<object>>([]);
  const handleChange = (id: number, status_state: boolean, name: string) => {
    setVouName(name);
    setStatus(status_state);
    setVouId(id);
    setOpenConfirmation(true);
  };

  const getVoucherDetails = async (id: number, name: string) => {
    try {
      console.log("inside getVoucherDetails");
      const selectedVoucherDetails = await api.get(`vouchers/${id}`);
      console.log(selectedVoucherDetails);
      setVouName(name);
      setVoucherDetails(selectedVoucherDetails);
      setShowVoucherDetails(true);
    } catch (error) {
      setSnackbarColor("red");
    }
  };
  const closeVoucherDetailsDialog = () => {
    setShowVoucherDetails(false);
  };
  const changeStatus = async (
    voucher_id: number | undefined,
    isactive: boolean
  ) => {
    try {
      const payload = {
        voucher_id: voucher_id,
        status: isactive,
      };

      const result = await updateVoucher(payload);

      if (result !== undefined) {
        setOpenConfirmation(false);
        setSnackbarColor("green");
        setVoucherStatus("Status updated successfully");
        await getVouchers();
      }
    } catch (error:any) {
      setSnackbarColor("red");
      setVoucherStatus(error.error);
    }
  };

  const onCloseSnackbar = () => {
    setVoucherStatus("");
  };

  if (voucher && voucher.length > 0) {
    return (
      <div className={classes.root1}>
        <SnackBar
          status={voucherStatus}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Voucher List"}
              data={
                voucher &&
                voucher.map((vou: any) => {
                  return [
                    vou.voucher_name,
                    vou.is_active ? "Yes" : "No",
                    <Grid
                      container
                      direction="row"
                      spacing={2}
                      justify="flex-end"
                      style={{ display: editVoucherPermission ? "" : "none" }}
                    >
                      <Grid item>
                        <Tooltip
                          title={
                            vou.is_active
                              ? "Change status to Inactive"
                              : "Change status to Active"
                          }
                        >
                          <Switch
                            checked={vou.is_active}
                            onChange={(e) =>
                              handleChange(
                                vou.id,
                                e.target.checked,
                                vou.voucher_name
                              )
                            }
                            style={{
                              color:
                                vou.is_active === true ? "#3d5a79" : undefined,
                            }}
                            color="primary"
                            name="status"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </Tooltip>
                      </Grid>
                    </Grid>,
                    <Grid container direction="row" spacing={2}>
                      <Grid item>
                        <Fab
                          size="small"
                          aria-label="edit"
                          // color="primary"
                          style={{ backgroundColor: "#3d5a79" }}
                          onClick={() =>
                            getVoucherDetails(vou.id, vou.voucher_name)
                          }
                        >
                          <Tooltip title="Voucher details">
                            <DescriptionIcon className={classes.detailIcon} />
                          </Tooltip>
                        </Fab>
                      </Grid>
                    </Grid>,
                  ];
                })
              }
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        {showVoucherDetails ? (
          <VoucherDetailsList
            voucherDetails={voucherDetails}
            voucherName={vouName}
            closeVoucherDetailsDialog={closeVoucherDetailsDialog}
          />
        ) : null}
        <Dialog
          open={openConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {voucher.length
                ? voucher && voucher.find((i: any) => i.id === vouId)?.is_active
                  ? `Would you like to change status of ${vouName} to Inactive?`
                  : `Would you like to change status of ${vouName} to Active?`
                : ""}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => changeStatus(vouId, status)} id="buton">
              Yes
            </Button>
            <Button
              onClick={() => setOpenConfirmation(false)}
              autoFocus
              id="buton"
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className={classes.root}>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Voucher List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
